import type { DefaultMenuItem, MenuItemDef } from 'ag-grid-community';

/** CDMX-15952: remove CSV/Excel export to prevent formula injection via downloaded files. */
export const EXPORT_MENU_ITEMS: DefaultMenuItem[] = [
  'export',
  'csvExport',
  'excelExport',
];

function menuItemName(
  item: MenuItemDef | DefaultMenuItem
): string | undefined {
  return typeof item === 'string' ? item : item.name;
}

/**
 * Strip AG Grid export menu entries from a menu item list.
 * Used by both column and context menus so CSV/Excel download is unavailable.
 */
export function withoutExportMenuItems(
  items: (MenuItemDef | DefaultMenuItem)[] | undefined
): (MenuItemDef | DefaultMenuItem)[] {
  const excluded = new Set<string>(EXPORT_MENU_ITEMS);
  return (items ?? []).filter(
    (item) => !excluded.has(menuItemName(item) ?? '')
  );
}
